import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import PaymentMethodButton from './PaymentMethodButton.jsx';
import classnames from 'classnames';
import loc from 'Components/languages';
import React, { Fragment, PureComponent } from 'react';
import styles from './PaymentMethods.less';

class PaymentMethods extends PureComponent {
	render() {
		const { salesOrder, paymentsInfo, onSelect, disabled } = this.props;
		const allowedReturnPaymentMethods = new Map(salesOrder.get('allowed_return_payment_methods'));
		const paymentMethods = (paymentsInfo && paymentsInfo.data) ? paymentsInfo.data.filter((paymentInfo) => (
			paymentInfo.code !== 'SB' &&
			(!allowedReturnPaymentMethods || allowedReturnPaymentMethods.size === 0 || allowedReturnPaymentMethods.has(paymentInfo.code))
		)) : [];
		return (
			<div className={ classnames('payMetContainer', styles.container) }>
				<h4 className="uk-text-uppercase">{ loc.methods }</h4>
				<div
					className={styles.paymentContainer}
					data-uk-overflow-auto="selContainer: .stepContainer; selContent: .payMetContainer"
				>
					{
						!disabled && (
							paymentMethods.length > 0 ? paymentMethods.map((paymentInfo, index) => (
								<PaymentMethodButton
									key={ `payment-method-container-${index}` }
									paymentMethod={ paymentInfo }
									onSelect={ onSelect }
								/>
							)) : (
								<></>
							)
						)
					}
				</div>
				<div className={ styles.placeholder } />
			</div>
		);
	}
}

PaymentMethods.propTypes = {
	salesOrder: PropTypes.instanceOf(Map).isRequired,
	disabled: PropTypes.bool,
	onSelect: PropTypes.func.isRequired,
};

export default connect(
	(state) => ({
		paymentsInfo: state.paymentsInfo,
	})
)(PaymentMethods);